import React, { useState } from "react";
import FormularioEstabelecimentoSaude from "./EstabelecimentoSaudeFrom";
import ConfirmacaoEstabelecimentoSaude from "./EstabelecimentoSaudeConfirm";
import apiService from "../../services/api";
import { usePopup } from "../common/Popup";

const DashboardContent = () => {
  const [step, setStep] = useState("form");
  const [formData, setFormData] = useState(null);
  const popup = usePopup();

  const handleNext = (data) => {
    setFormData(data);
    setStep("confirm");
  };

  const handleEdit = () => {
    setStep("form");
  };

  const handleSubmit = async () => {
    try {
      const payload = {
        tipo: formData.tipoEstabelecimento,
        nome: formData.nomeEstabelecimento,
        nomeDiretor: formData.nomeDiretor,
        cargoDiretor: formData.cargoDiretor,
        nomeDiretorTecnico: formData.nomeDiretorTecnico,
        cargoDiretorTecnico: formData.cargoDiretorTecnico,
        nomeResponsavelTecnico: formData.nomeResponsavelEstagio,
        cargoResponsavelTecnico: formData.cargoResponsavelEstagio
      };

      await apiService.createEstabelecimentoSaude(payload);

      await popup.alert({
        icon: "success",
        message: "Estabelecimento de saúde cadastrado com sucesso!",
      });
      // Resetar ou redirecionar conforme a necessidade do fluxo
      setStep("form");
      setFormData(null);

    } catch (error) {
      console.error("Erro ao salvar estabelecimento:", error);
      await popup.alert({
        icon: "warning",
        title: "Erro ao cadastrar",
        message: "Verifique os dados e tente novamente.",
      });
    }
  };

  return (
    <>
      {step === "form" && (
        <FormularioEstabelecimentoSaude onNext={handleNext} />
      )}

      {step === "confirm" && (
        <ConfirmacaoEstabelecimentoSaude
          data={formData}
          onEdit={handleEdit}
          onConfirm={handleSubmit}
        />
      )}
    </>
  );
};

export default DashboardContent;